var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row justify-content-between"},[_c('span',{staticClass:"sub-title",domProps:{"textContent":_vm._s(_vm.title)}}),(!_vm.isFree)?_c('span',{staticClass:"price",domProps:{"textContent":_vm._s(_vm.formattedPrice)}}):_c('span',{staticClass:"price green"},[_vm._v("Gratis")])])
}
var staticRenderFns = []

export { render, staticRenderFns }